import { __decorate, __metadata } from 'tslib';
import { isDevMode, TemplateRef, ViewContainerRef, Input, Directive, Component, NgModule, ɵɵdefineInjectable, ɵɵinject, Injectable } from '@angular/core';
import { isOn, set } from 'feature-toggle-service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';

const _c0 = ["*"];
let FeatureToggleDirective = class FeatureToggleDirective {
    constructor(templateRef, viewContainer) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.isOn = false;
    }
    ngOnInit() {
        if (!this.featureToggle) {
            throw new Error('Attribute `featureToggle` should not be null or empty');
        }
        this.shouldRender();
    }
    ngDoCheck() {
        if (this.isOn !== this.isOnCheck(this.featureToggle)) {
            this.shouldRender();
        }
    }
    shouldRender() {
        this.isOn = this.isOnCheck(this.featureToggle);
        if (this.isOn) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
        else {
            this.viewContainer.clear();
        }
    }
    isOnCheck(featureToggle) {
        if (typeof featureToggle !== 'string' && !Array.isArray(featureToggle)) {
            if (isDevMode()) {
                console.error('`NgxFeatureToggle`: `featureToggle` should receive an array or an string as a value.');
            }
            return false;
        }
        return [].concat(featureToggle).every((toggle) => toggle[0] === '!' ? !isOn(toggle.replace('!', '')) : isOn(toggle));
    }
};
FeatureToggleDirective.ɵfac = function FeatureToggleDirective_Factory(t) { return new (t || FeatureToggleDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
FeatureToggleDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FeatureToggleDirective, selectors: [["", "featureToggle", ""]], inputs: { featureToggle: "featureToggle" } });
FeatureToggleDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef }
];
__decorate([
    Input(),
    __metadata("design:type", Object)
], FeatureToggleDirective.prototype, "featureToggle", void 0);
FeatureToggleDirective = __decorate([ __metadata("design:paramtypes", [TemplateRef,
        ViewContainerRef])
], FeatureToggleDirective);

let FeatureToggleProviderComponent = class FeatureToggleProviderComponent {
    constructor() {
        this.features = {};
        this.currentConfig = {};
    }
    ngOnInit() {
        if (typeof this.features !== 'object') {
            throw new Error('Attribute `features` should not be null or empty');
        }
        this.setFeatureToggles();
    }
    ngDoCheck() {
        this.setFeatureToggles();
    }
    setFeatureToggles() {
        if (this.currentConfig !== this.features) {
            // Using `Object.assign()` method for bundle size decreasing purposes
            // It's required since it needs a new memory reference
            // for the new object value
            this.currentConfig = Object.assign({}, this.features);
            set(this.features);
        }
    }
};
FeatureToggleProviderComponent.ɵfac = function FeatureToggleProviderComponent_Factory(t) { return new (t || FeatureToggleProviderComponent)(); };
FeatureToggleProviderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FeatureToggleProviderComponent, selectors: [["feature-toggle-provider"]], inputs: { features: "features" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function FeatureToggleProviderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Object)
], FeatureToggleProviderComponent.prototype, "features", void 0);

let FeatureToggleModule = class FeatureToggleModule {
};
FeatureToggleModule.ɵfac = function FeatureToggleModule_Factory(t) { return new (t || FeatureToggleModule)(); };
FeatureToggleModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FeatureToggleModule });
FeatureToggleModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

let NgxFeatureToggleRouteGuard = class NgxFeatureToggleRouteGuard {
    constructor(router) {
        this.router = router;
    }
    isDevMode() {
        return isDevMode();
    }
    isOnCheck(route) {
        if (!route ||
            !route.data ||
            (typeof route.data.featureToggle !== 'string' &&
                !Array.isArray(route.data.featureToggle))) {
            if (this.isDevMode()) {
                console.error(
                // tslint:disable-next-line: max-line-length
                '`NgxFeatureToggleRouteGuard` need to receive `featureToggle` as data as an array or string in your route configuration.');
            }
            return false;
        }
        const hasAllTogglesOn = [].concat(route.data.featureToggle).every((toggle) => toggle[0] === '!' ? !isOn(toggle.replace('!', '')) : isOn(toggle));
        if (!hasAllTogglesOn && route.data.redirectTo) {
            this.router.navigate([].concat(route.data.redirectTo));
        }
        return hasAllTogglesOn;
    }
    canLoad(route) {
        return this.isOnCheck(route);
    }
    canActivateChild(route) {
        return this.isOnCheck(route);
    }
    canActivate(route) {
        return this.isOnCheck(route);
    }
};
NgxFeatureToggleRouteGuard.ɵfac = function NgxFeatureToggleRouteGuard_Factory(t) { return new (t || NgxFeatureToggleRouteGuard)(ɵngcc0.ɵɵinject(ɵngcc1.Router)); };
NgxFeatureToggleRouteGuard.ctorParameters = () => [
    { type: Router }
];
NgxFeatureToggleRouteGuard.ɵprov = ɵɵdefineInjectable({ factory: function NgxFeatureToggleRouteGuard_Factory() { return new NgxFeatureToggleRouteGuard(ɵɵinject(Router)); }, token: NgxFeatureToggleRouteGuard, providedIn: "root" });
NgxFeatureToggleRouteGuard = __decorate([ __metadata("design:paramtypes", [Router])
], NgxFeatureToggleRouteGuard);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FeatureToggleDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: '[featureToggle]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }]; }, { featureToggle: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FeatureToggleProviderComponent, [{
        type: Component,
        args: [{
                selector: 'feature-toggle-provider',
                template: '<ng-content></ng-content>'
            }]
    }], function () { return []; }, { features: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FeatureToggleModule, [{
        type: NgModule,
        args: [{
                declarations: [FeatureToggleProviderComponent, FeatureToggleDirective],
                exports: [FeatureToggleProviderComponent, FeatureToggleDirective],
                imports: [CommonModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FeatureToggleModule, { declarations: function () { return [FeatureToggleProviderComponent, FeatureToggleDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [FeatureToggleProviderComponent, FeatureToggleDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFeatureToggleRouteGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.Router }]; }, null); })();

/*
 * Public API Surface of ngx-feature-toggle
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FeatureToggleDirective, FeatureToggleModule, FeatureToggleProviderComponent, NgxFeatureToggleRouteGuard };

